import { render, staticRenderFns } from "./ActivitiesClient.vue?vue&type=template&id=d177e400&scoped=true&"
import script from "./ActivitiesClient.vue?vue&type=script&lang=js&"
export * from "./ActivitiesClient.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesClient.vue?vue&type=style&index=0&id=d177e400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d177e400",
  null
  
)

export default component.exports